Vendd.Scripts.load(function () {
    'use strict';
    var TrackingScriptName = 'EnhancedEcommerce';

    if (!LhApp.Context.IsConsentsEnabled)
        $('#EnhancedEcommerceGlobalVariablesEl').remove();


    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Add, TrackingScriptName, function (envelope) {
        if (window.EnhancedEcommerceGlobalVariables) {

            var productId = envelope.message.data.id;
            var skuId = envelope.message.data.skuId;
            var quantity = envelope.message.data.qty;
            var enhancedInfo = envelope.message.data.enhancedInfo;
            var color = enhancedInfo ? enhancedInfo.color : '';
            var size = enhancedInfo ? enhancedInfo.size : '';
            var list = enhancedInfo ? enhancedInfo.list : '';


            var prodData = undefined;
            var lists = window.EnhancedEcommerceGlobalVariables.ProductListsData;

            if (lists && lists[list]) {

                prodData = GetProductData(productId, list, lists);

            } else if (list == 'productDetails') {
                //product details add to cart section

                var snippet = $('.x-product-details').data('enhanced-variables');

                var name = snippet.name;
                var price = snippet.price;
                if (snippet.priceWithoutVat)
                    price = snippet.priceWithoutVat;
                var brand = snippet.brand;
                var category = snippet.category;
                color = snippet.color;
                size = snippet.size;

                prodData = { Name: $.trim(name), Price: $.trim(price), Brand: $.trim(brand), Category: $.trim(category), Position: 0 }
            } else {
                // todo
                // when there is no list context available pass parameters
                // raised by cart search box module
                return;
            }


            if (prodData !== undefined && typeof ga !== 'undefined') {

                ga("ec:addProduct", {
                    id: productId,
                    name: prodData.Name,
                    price: prodData.Price,
                    brand: prodData.Brand,
                    category: prodData.Category,
                    variant: color,
                    dimension1: size,
                    position: prodData.Position,
                    quantity: quantity
                });

                ga("ec:setAction", "add");
                ga("send", "event", list, "click", "addToCart");
            }
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Remove, TrackingScriptName, function (envelope) {
        if (window.EnhancedEcommerceGlobalVariables) {

            var identifierId = envelope.message.data.id;

            var cartItem = $('li.cart-item[data-identifier=' + identifierId + ']');

            var name = $.trim($('a.title span.name', cartItem).text());
            var price = $('.prices-wrapper .current', cartItem).text();

            var productId = cartItem.data('productid');
            var quantity = cartItem.data('quantity');
            var brand = cartItem.data('manufacturer');
            var category = cartItem.data('category');

            var color = cartItem.data('color');
            var size = cartItem.data('size');


            if (productId !== undefined && typeof ga !== 'undefined') {

                ga("ec:addProduct", {
                    id: productId,
                    name: name,
                    price: price,
                    brand: brand,
                    category: category,
                    variant: color,
                    dimension1: size,
                    position: "0",
                    quantity: quantity
                });

                ga("ec:setAction", "remove");
                ga("send", "event", "cart", "click", "removeFromCart");
            }
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.ProductSelected, TrackingScriptName, function (envelope) {

        if (window.EnhancedEcommerceGlobalVariables) {

            var productId = envelope.message.data.id;
            var list = envelope.message.data.list;

            var lists = window.EnhancedEcommerceGlobalVariables.ProductListsData;

            var prodData = GetProductData(productId, list, lists);

            if (prodData !== undefined && typeof ga !== 'undefined') {

                ga("ec:addProduct", {
                    id: productId,
                    name: prodData.Name,
                    price: prodData.Price,
                    brand: prodData.Brand,
                    category: prodData.Category,
                    position: prodData.Position
                });

                ga("ec:setAction", "click", { list: list });
                ga("send", "event", list, "click", "");
            }
        }

    });

    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPageSuccess, TrackingScriptName, function (envelope) {
        var model = envelope.message.data.model;
        if (!window.EnhancedEcommerceGlobalVariables || envelope.message.data.type != 'productList' || !model.Items || model.Items.length < 1)
            return;

        var list = model.SeoTitle;
        var lists = window.EnhancedEcommerceGlobalVariables.ProductListsData || [];
        var updatedProducts = [];

        if (list in lists) {

            $.each(envelope.message.data.model.Items[0], function (idx, item) {

                updatedProducts.push({
                    ProductId: '' + item.Id,
                    Name: item.Title,
                    Brand: item.Manufacturer,
                    Category: item.Category,
                    Color: item.sel_color,
                    Size: item.sel_size,
                    Price: item.Prices.Price.CurrentPriceValue,
                    List: list,
                    Position: item.Index,
                    Quantity: 0,
                    Properties: []
                });

                ga("ec:addImpression", {
                    id: '' + item.Id,
                    name: item.Title,
                    price: item.Prices.Price.CurrentPriceValue,
                    brand: item.Manufacturer,
                    category: item.Category,
                    position: item.Index,
                    list: list
                });
            });

            if (updatedProducts.length > 0) {
                lists[list] = $.merge(lists[list], updatedProducts);
                ga("send", "pageview", window.location.href);
            }
        }


    });


    Vendd.MessageBus.subscribe(Vendd.LazyProductList.Messages.LazyProductListSuccess, TrackingScriptName, function (envelope) {
        var model = envelope.message.data.model;
        if (!window.EnhancedEcommerceGlobalVariables || !model.Items || model.Items.length < 1)
            return;

        var list = model.SeoTitle;
        var lists = window.EnhancedEcommerceGlobalVariables.ProductListsData || [];
        var updatedProducts = [];

        $.each(model.Items[0], function (idx, item) {
            updatedProducts.push({
                ProductId: '' + item.Id,
                Name: item.Title,
                Brand: item.Manufacturer,
                Category: item.Category,
                Color: item.sel_color,
                Size: item.sel_size,
                Price: item.Prices.Price.CurrentPriceValue,
                List: list,
                Position: item.Index,
                Quantity: 0,
                Properties: []
            });

            ga("ec:addImpression", {
                id: '' + item.Id,
                name: item.Title,
                price: item.Prices.Price.CurrentPriceValue,
                brand: item.Manufacturer,
                category: item.Category,
                position: item.Index,
                list: list
            });
        });


        if (updatedProducts.length > 0) {

            if (list in lists) {
                window.EnhancedEcommerceGlobalVariables.ProductListsData[list] = $.merge(window.EnhancedEcommerceGlobalVariables.ProductListsData[list], updatedProducts);
            } else {
                window.EnhancedEcommerceGlobalVariables.ProductListsData[list] = updatedProducts;
            }
        }
    });


    function GetProductData(productId, list, lists) {

        var pdata = undefined;

        for (var li in lists) {

            if (li !== list) { continue; }

            if (li.length > 0) {

                var curList = lists[li];

                //iterate products
                for (var i = 0; i < curList.length; i++) {

                    var product = curList[i];

                    if (product.ProductId == productId) {
                        pdata = product;
                        break;
                    }
                }
            }
        }

        return pdata;
    };

});